import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_EUROPEAN_UNION_STATE,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    dateTravelArrangementsWereMade: '',
    dateOfInitialPaymentDeposit: '',
    doYouHaveOtherTypeOfPetInsurance: 'false',
    companyName: '',
    address: '',
    cityOrTown: '',
    country: '',
    postalCode: '',
    policyId: '',
    typeOfPolicy: '',
    contact: '',
    phoneNumber: '',
    haveYouFiledAClaimWithTheirOfficeAtThisTime: '',
    pleaseNoteTheirResponse: '',
    whyNot: '',
    petName: '',
    canineOrFeline: 'canine',
    petWeight: '',
    unit: '',
    dateSicknessOrInjuryBegan: '',
    dateFirstTreated: '',
    forEUCitizens: 'false',
    ifYesWasTheEHIC: 'false',
    ifNoPleaseExplain: '',
    changeTo: 'false',
    ifYesNameOfPhysicianCurrentlyTreatingThis: '',
    // New Screen
    isTheClaimTheResultOfASicknessOrInjury: '',
    natureOfSickness: '',
    accidentOfInjury: '',
    dateNature: '',
    placeNature: '',
    fromDateNature: '',
    toDateNature: '',
    endDateNature: '',
    wasThereAnAccidentReportForThisIncident: 'false',
    expenseDescriptionOfItems: [],
    natureOfInjury: '',
  },
  errors: [],
});

const initialEuropeanUnionState = {
  form: {
    forEUCitizens: 'false',
    ifYesWasTheEHIC: 'false',
    ifNoPleaseExplain: '',
  },
};

function petMedicalStepReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_EUROPEAN_UNION_STATE:
      return state.mergeDeep(initialEuropeanUnionState);
    // case RESET_TRAVEL_DELAY_STATE:
    //   return state
    //       .setIn(['form', 'descriptionOfItemsForDamaged'], [])
    //       .mergeDeep(initialForBaggageDelayState);
    default:
      return state;
  }
}

export default petMedicalStepReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.PetMedicalStep/reducer.js